var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 13.8971L16.5273 10.6627H13.3984V8.55334C13.3984 7.63928 13.8203 6.79553 15.2266 6.79553H16.668V4.01819C16.668 4.01819 15.3672 3.77209 14.1367 3.77209C11.5703 3.77209 9.88281 5.35413 9.88281 8.16663V10.6627H7V13.8971H9.88281V21.7721H13.3984V13.8971H16.0352Z",
    fill: "#022219"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFbIcon);
export default __webpack_public_path__ + "static/media/footer_fb_icon.057179d878c026a3327990d7c5065d5e.svg";
export { ForwardRef as ReactComponent };